import React, { FC } from 'react';
import classNames from 'classnames';
import Tooltip from 'react-tooltip';
import { Hyperlink } from '../../components/Hyperlink';
import { addSeparatorBetweenElements } from '../../utils/jsxUtils';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import styles from './decision_header_subtitle.module.scss';

type Props = {
  source: string;
  arretDecAtt?: Array<string> | null;
  solution?: string;
  validation?: {
    url: string;
    validated: boolean;
    ofJuridiction: string;
    juridiction: string;
    solution?: string;
  };
  docId: string;
  automaticMetadata?: { [s: string]: string };
};

export const DecisionHeaderSubtitle: FC<Props> = ({
  solution,
  validation,
  docId,
  automaticMetadata,
  source,
}) => {
  const tags = [];

  if (solution || validation) {
    tags.push(
      <>
        {solution && <span dangerouslySetInnerHTML={{ __html: solution }} />}
        {validation && (
          <span>
            <span>
              {` `}→{` `}
              {validation.juridiction}
            </span>
            {`\u00a0`}:{`\u00a0`}
            <Hyperlink
              href={buildUrlWithParameters(validation.url, {
                source: `${source}_validation`,
              })}
              className={classNames(
                validation.validated && styles.validated,
                !validation.validated && styles.notValidated,
              )}
              data-tip={`Lire la décision ${validation.ofJuridiction}`}
              data-for={`validation-${docId}`}
            >
              {validation.solution}
            </Hyperlink>
            <Tooltip id={`validation-${docId}`} effect="solid" />
          </span>
        )}
      </>,
    );
  }

  if (automaticMetadata) {
    Object.keys(automaticMetadata).forEach((key) => {
      tags.push(
        <span>
          <span>{`${key}\u00a0:\u00a0`}</span>
          <span dangerouslySetInnerHTML={{ __html: automaticMetadata[key] }} />
        </span>,
      );
    });
  }

  return (
    <div className={styles.container}>
      {addSeparatorBetweenElements(tags, ' | ')}
    </div>
  );
};
